import { CapacityCalculationParams } from "./type";

export function isBookingFull({
  nodeRequirePlayerCounts,
  nodeStandardCapacity,
  isGolfCourse,
  playersLength,
  groupSize = 1,
  bookingType,
  bookingWizardCapacity,
  nodeUsedCapacity,
}: CapacityCalculationParams): boolean {
  if (bookingType === "LessonBooking") {
    return groupSize === playersLength;
  }
  if (bookingType === "RequestBooking") {
    return bookingWizardCapacity === playersLength;
  } else if (!nodeRequirePlayerCounts || isGolfCourse) {
    const usedCapacity = nodeUsedCapacity ?? 0;
    return (nodeStandardCapacity || 0) - usedCapacity === playersLength;
  }
  return playersLength === groupSize;
}
